import { render, staticRenderFns } from "./MMP_MainMenu.vue?vue&type=template&id=cc7150cc&"
import script from "./MMP_MainMenu.vue?vue&type=script&lang=js&"
export * from "./MMP_MainMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports